import React from "react";

import {
  Button,
  ButtonGroup,
  Popover,
  Classes,
  Tag,
  Intent
} from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";
import ComingSoon from "../ComingSoon/ComingSoon";

import moment from "moment";
import currency from "currency-formatter";

import classNames from "classnames";
import styles from "./ProductOpportunityLozenge.module.scss";

function ProductOpportunityLozenge({
  activeOpportunity,
  opportunities,
  onClick = () => {}
}) {
  if (!activeOpportunity && (!opportunities || !opportunities.length)) {
    return <span>--</span>;
  }

  if (!activeOpportunity) {
    return (
      <Tag
        large
        icon={<Icon name="dot" color="#ec7c7c" />}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        intent={Intent.DANGER}
        minimal
        round
      >
        Inactive
      </Tag>
    );
  }

  return (
    <ButtonGroup onClick={(e) => e.stopPropagation()}>
      <Tag
        icon={<Icon name="dot" color="#65cfa1" />}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        large
        minimal
        round
      >
        {!activeOpportunity.isPercentage ? "$" : ""}
        {currency.format(activeOpportunity.amount, { format: "USD" })}
        {activeOpportunity.isPercentage ? "%" : ""}
      </Tag>
    </ButtonGroup>
  );
}

export default ProductOpportunityLozenge;
